import { solidstate } from ":setup/qstate";

const en = {
  forms: {
    global: {
      email: {
        label: "Email",
        hint: "Please enter the email address used for your registration in the third edition of Designathon.",
      },
      button: {
        valid: "Submit",
        invalid: "Submit",
      },
    },
  },

  page_not_found: {
    error: "404 Error",
    title: "Page Not Found",
    subtitle:
      "Sorry, the time period for attaching documents and confirming attendance has ended. See you in the next edition.",
    back: "Go Back",
  },
};

const translations: Record<TRANSLATION_LOCALES, TRANSLATION_SCHEMA> = {
  en,
  ar: {
    forms: {
      global: {
        email: {
          label: "البريد الالكتروني",
          hint: "الرجاء إدخال البريد الإلكتروني المستخدم في تسجيلكم في النسخة الثالثة من ديزايناثون.",
        },
        button: {
          valid: "إرسال",
          invalid: "إرسال",
        },
      },
    },

    page_not_found: {
      error: "خطأ 404",
      title: "لم يتم إيجاد الصفحة",
      subtitle: "عذراً، تم انتهاء الفترة الزمنية لإرفاق المستندات وتأكيد الحضور، نراكم في النسخة القادمة",
      back: "العودة للصفحة السابقة",
    },
  },
};
export type TRANSLATION_SCHEMA = typeof en;

export type TRANSLATION_LOCALES = "en" | "ar";
export const $i18n_state = solidstate.create("en" as TRANSLATION_LOCALES);
export const locale = () => $i18n_state.value;
export const setLocale = (locale: TRANSLATION_LOCALES) => {
  $i18n_state.set(locale);
  document.documentElement.setAttribute("lang", locale);
  if (locale === "ar") {
    document.documentElement.setAttribute("dir", "rtl");
  } else {
    document.documentElement.setAttribute("dir", "ltr");
  }
};
export const t = () => {
  return translations[$i18n_state.value];
};
